module.exports = __webpack_public_path__ + "img/ringwedding@2x.859939c.jpg";